import { TouchableOpacity } from "react-native";
import React, { useState } from "react";

import { Colors } from "colors";
import ImageView from "../../src/image";
import { Svg } from "assets/svg";

const AIstylistButtonCop = ({ setIsOpenAskAI }) => {
  return (
    <>
      <TouchableOpacity
        onPress={() => setIsOpenAskAI(true)}
        style={{
          backgroundColor: Colors.white,
          position: "absolute",
          left: 40,
          top: 20,
        }}
      >
        <ImageView
          source={Svg.aistylistIcon}
          style={{ width: 144, height: 36 }}
          resizeMode="contain"
        />
      </TouchableOpacity>
    </>
  );
};

export default AIstylistButtonCop;
